import { put, select, takeLeading } from 'redux-saga/effects';

import { callApi, handleError, ResponseError } from 'helpers/saga-helpers';
import {
  REQUEST_MAKE_JUDGEMENT_ADD_DECISION,
  REQUEST_VALIDATE_EXPERT_REPORT,
  REQUEST_VALIDATE_JUDGEMENT_APPEAL,
  REQUEST_VALIDATE_JUDGEMENT_ON_MERITS,
  CREATE_CIVIL_PROCEEDING,
  REQUEST_ASSIGNED_EXPERT,
  REQUEST_VALIDATE_DISCLAIMER_WARRANTY,
  REQUEST_UPDATE_CIVIL,
  REQUEST_VALIDATE_CIVIL_PROCEEDING,
  REQUEST_MAKE_JUDGEMENT_ADD_DOCUMENT_DECISION,
  REQUEST_VALIDATE_ADD_VICTIMS_CARD,
  REQUEST_CREATE_VEHICLES,
  REQUEST_MAKE_DECISION_MISSION_EXPERTISE,
  REQUEST_MAKE_DECISION_MISSION_NOTICE_DEFICIENCY,
  REQUEST_GET_EXPERTS_USERS,
  REQUEST_ADD_APPRECIATION,
  REQUEST_UPDATE_CIVIL_PROCEEDING,
  REQUEST_SET_IS_SUSPICIOS_CLAIM,
  CREATE_JUDGEMENT_ADD,
  REQUEST_LOCK_CLAIM,
  REQUEST_UNLOCK_CLAIM,
  MAKE_DECISION_DOCUMENT_IMAGING,
  REQUEST_CHECK_CIVIL_PARTY_JUDICIARY_PROCESS,
  REQUEST_GET_CLAIM_HISTORY_ACTIONS,
  REQUEST_GET_CLAIM_HISTORY_SAGIS,
  REQUEST_SET_STATUS_CLAIM_SAGIS,
  REQUEST_ADD_STAKE_HOLDER,
  REQUEST_UPDATE_PRIORITY_CLAIM_PROVISION,
  REQUEST_GET_INSTRUCTIONS,
  REQUEST_CREATE_INSTRUCTIONS,
  REQUEST_UPDATE_INSTRUCTIONS,
  REQUEST_CREATE_INCOME_CERTIFICATE,
  REQUEST_UPDATE_INCOME_CERTIFICATE,
  REQUEST_MAKE_DECISION_INCOME_CERTIFICATE,
  REQUEST_MAKE_DECISION_SUPPORT_DOCUMENT,
  REQUEST_GET_PENDING_TASKS_CLAIM,
  REQUEST_GET_CLAIM_CIVIL_PARTY,
  REQUEST_ARCHIVE_JUDGEMENT,
  REQUEST_UPLOAD_DOCUMENT_MANAGER,
  REQUEST_GET_DECISION_FLOW_VICTIMS,
} from 'containers/CourtManagerLegalProceedings/constants';

import {
  IAddVictimsAction,
  IAssignedExpertAction,
  ICreateCivilProceedingAction,
  ICreateStakeHolder,
  IExpertReportValidationSaga,
  IJudgementAddValidationSaga,
  IJudgementAppealValidationAction,
  IJudgementOnMeritsValidationAction,
  IUpdatedCivilProceedingAction,
  IWarrantyReasonAction,
} from 'containers/CourtManagerLegalProceedings/typings';
import { requestFeeNotesByClaimNumb } from 'containers/ManagerFeeNote/actions';
import accessTokenStorage from 'containers/services/security/access-token-storage';
import {
  requestGetAppealOnMeritsMultiple,
  requestGetCivilProceeding,
  requestGetExpertiseRaport,
  requestGetJudgementAdd,
  requestGetJudgementOnMerits,
  requestGetJudgementOnMeritsMultiple,
} from 'containers/LawyerLegalProceedingsPage/actions';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import { get, isEmpty, isNil } from 'lodash';
import { requestClaimRecap } from 'containers/RecapManagerPage/actions';
import {
  requestGetExpertiseVictim,
  requestGetMissionPostPone,
  requestGetMissionPostPoneExpertise,
} from 'containers/ExpertExpertise/actions';
import {
  setCheckCivilPartyJudiciaryProcess,
  setClaimHistoryActions,
  setDecisionsJudgementIds,
  setClaimHistorySagis,
  setInstructions,
  setPendingTasksClaim,
  setClaimCivilParty,
  requestGetPendingTasksClaim,
  requestGetClaimHistorySagis,
  setDecisionFlowVictims,
} from 'containers/CourtManagerLegalProceedings/actions';
import { MISSION_POSTPONE_TYPE } from 'containers/data-structure';
import { requestSetExpertUsers } from 'containers/CourtManagerLegalProceedings/actions';
import { makeSelectLockedClaim } from 'containers/LawyerLegalProceedingsPage/selectors';
import { requestSagisClaimInfo } from 'containers/CourtManagerLegalProceedings/Provision/redux/actions';
import {
  requestGetFeeNotesTransaction,
  requestGetMissionVictimExpertise,
  requestGetTransaction,
} from 'containers/TransactionManagerTimeLine/actions';
import { constructUrl } from 'services/utils';
import { setNotification } from 'containers/AppContainer/actions';
import { LOADERS } from 'containers/AppContainer/Loader/constants';
import { PROCEDURE_TYPES } from 'containers/LawyerLegalProceedingsPage/constants';
import { requestSearchClaims } from 'containers/IdentificationPage/actions';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { requestGetProvisionalClaimDetails } from 'containers/ProvisionalClaimRecap/actions';

export function* makeJudgementAddDecision(
  action: IJudgementAddValidationSaga,
): Generator<unknown> {
  const { decision, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/judgement/make-judgement-add-decision`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ judgementAdd: decision }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield put(
      setDecisionsJudgementIds({
        judgementAddDocumentId: get(decision, 'judgementAddDocumentId', null),
        judgementId: get(decision, 'id', null),
      }),
    );
    yield put(
      requestGetJudgementAdd(
        get(decision, 'claimId'),
        get(decision, 'procedureType'),
        get(decision, 'judiciaryProcessId'),
      ),
    );
    featureService.hasFeature(FEATURES.EVOLUTION_P3)
      ? yield put(
          requestFeeNotesByClaimNumb(get(decision, 'claimNumber'), [], true),
        )
      : yield put(requestFeeNotesByClaimNumb(get(decision, 'claimNumber')));
    yield successCallback();
  }
}

export function* makeJudgementAddDecisionSaga() {
  yield takeLeading(
    REQUEST_MAKE_JUDGEMENT_ADD_DECISION,
    makeJudgementAddDecision,
  );
}
export function* makeJudgementAddDocumentDecision(
  action: IJudgementAddValidationSaga,
): Generator<unknown> {
  const { decision, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/judgement-add-document/make-decision`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(decision),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield put(
      setDecisionsJudgementIds({
        judgementAddDocumentId: get(decision, 'id', null),
        judgementId: null,
      }),
    );
    yield successCallback();
    featureService.hasFeature(FEATURES.EVOLUTION_P3)
      ? yield put(
          requestFeeNotesByClaimNumb(get(decision, 'claimNumber'), [], true),
        )
      : yield put(requestFeeNotesByClaimNumb(get(decision, 'claimNumber')));
  }
}

export function* makeJudgementAddDocumentDecisionSaga() {
  yield takeLeading(
    REQUEST_MAKE_JUDGEMENT_ADD_DOCUMENT_DECISION,
    makeJudgementAddDocumentDecision,
  );
}

export function* validateExpertReport(
  action: IExpertReportValidationSaga,
): Generator<unknown> {
  const { expertReport, successCallback } = action;
  const token = !get(action, 'expertReport.isLawyer')
    ? accessTokenStorage.get().token
    : yield select(makeSelectKeycloakToken());
  const path = `/corporeal/judgement/change-expert-report`;

  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...expertReport }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield put(
      requestGetExpertiseRaport(
        expertReport.claimId,
        expertReport.procedureType,
        expertReport.judiciaryProcessId,
      ),
    );
    if (!get(action, 'expertReport.isLawyer')) {
      yield put(requestClaimRecap(expertReport.claimId));
    }
    yield successCallback();
  }
}

export function* validateExpertReportSaga() {
  yield takeLeading(REQUEST_VALIDATE_EXPERT_REPORT, validateExpertReport);
}

export function* validateJudgementOnMerits(
  action: IJudgementOnMeritsValidationAction,
): Generator<unknown> {
  try {
    const { judgementOnMerits, successCallback } = action;
    const token = !get(action, 'judgementOnMerits.isLawyer')
      ? accessTokenStorage.get().token
      : yield select(makeSelectKeycloakToken());
    const sagisEvaluations = [...judgementOnMerits.sagisEvaluations];
    const provisionBody = judgementOnMerits.provisionBody;
    delete judgementOnMerits.sagisEvaluations;
    const path = !get(action, 'judgementOnMerits.isLawyer')
      ? `/corporeal/judgement/make-judgement-on-merits-decision/v2`
      : `/corporeal/judgement/change-judgement-on-merits`;

    const options = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        judgementOnMeritsValidationRequest: judgementOnMerits,
        sagisEvaluations,
        provisionBody,
      }),
    };

    const errorResponse = yield callApi(path, {}, options);

    if (!errorResponse) {
      if (!get(action, 'judgementOnMerits.isLawyer')) {
        yield put(
          setDecisionsJudgementIds({
            judgementAddDocumentId: null,
            judgementId: get(judgementOnMerits, 'judgementId', null),
          }),
        );
        featureService.hasFeature(FEATURES.EVOLUTION_P3)
          ? yield put(
              requestFeeNotesByClaimNumb(
                get(judgementOnMerits, 'claimNumber'),
                [],
                true,
              ),
            )
          : yield put(
              requestFeeNotesByClaimNumb(get(judgementOnMerits, 'claimNumber')),
            );
        yield put(requestClaimRecap(get(judgementOnMerits, 'claimId')));
      }
      get(judgementOnMerits, 'isMultiple')
        ? yield put(
            requestGetJudgementOnMeritsMultiple(
              get(judgementOnMerits, 'claimId'),
              get(judgementOnMerits, 'procedureType'),
              get(judgementOnMerits, 'judiciaryProcessId'),
            ),
          )
        : yield put(
            requestGetJudgementOnMerits(
              get(judgementOnMerits, 'claimId'),
              get(judgementOnMerits, 'procedureType'),
              get(judgementOnMerits, 'judiciaryProcessId'),
            ),
          );
      yield put(
        requestGetJudgementAdd(
          get(judgementOnMerits, 'claimId'),
          get(judgementOnMerits, 'procedureType'),
          get(judgementOnMerits, 'judiciaryProcessId'),
        ),
      );
    }

    if (!errorResponse && successCallback) {
      yield successCallback();
    }
  } catch (err) {
    yield* handleError((err as unknown) as ResponseError);
  }
}
export function* requestCreateJudgementAdd(action: {
  type: string;
  payload: {};
  callback: Function;
  handleError: Function;
}): Generator<unknown> {
  try {
    const { payload, callback, handleError: handleErrorValidation } = action;
    const token = accessTokenStorage.get().token;
    if (!token) return;
    const path = `/corporeal/judgement/add-judgement-add`;

    const options = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    };

    const errorResponse = yield callApi(path, {}, options, []);
    if (!errorResponse && callback) {
      if (!get(payload, 'judgementAdd.isLawyer')) {
        yield put(
          requestGetJudgementAdd(
            get(payload, 'judgementAdd.claimId'),
            get(payload, 'judgementAdd.procedureType'),
            get(payload, 'judgementAdd.judiciaryProcessId'),
          ),
        );
        featureService.hasFeature(FEATURES.EVOLUTION_P3)
          ? yield put(
              requestFeeNotesByClaimNumb(
                get(payload, 'judgementAdd.claimNumber'),
                [],
                true,
              ),
            )
          : yield put(
              requestFeeNotesByClaimNumb(
                get(payload, 'judgementAdd.claimNumber'),
              ),
            );
        yield put(
          requestGetPendingTasksClaim({
            claimNumber: get(payload, 'judgementAdd.claimNumber'),
            isImagineDocuments: true,
          }),
        );
      }
      yield callback();
    }
    if (errorResponse) {
      yield handleErrorValidation();
    }
  } catch (err) {
    yield* handleError((err as unknown) as ResponseError);
  }
}
export function* requestCreateJudgementAddSaga() {
  yield takeLeading(CREATE_JUDGEMENT_ADD, requestCreateJudgementAdd);
}

export function* validateJudgementOnMeritsSaga() {
  yield takeLeading(
    REQUEST_VALIDATE_JUDGEMENT_ON_MERITS,
    validateJudgementOnMerits,
  );
}
export function* validateJudgementAppeal(
  action: IJudgementAppealValidationAction,
): Generator<unknown> {
  const { judgementAppeal, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/judgement/make-appeal-judgement-decision`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...judgementAppeal }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
  }
}

export function* validateJudgementAppealSaga() {
  yield takeLeading(REQUEST_VALIDATE_JUDGEMENT_APPEAL, validateJudgementAppeal);
}
export function* createCivilProceeding(
  action: ICreateCivilProceedingAction,
): Generator<unknown> {
  const { civilProceeding, successCallback } = action;
  const token = accessTokenStorage.get().token;
  if (!token) return;
  const path = `/corporeal/judiciary-process`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...civilProceeding }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield put(requestGetCivilProceeding(get(civilProceeding, 'claimId')));
    yield successCallback();
  }
}
export function* createCivilProceedingSaga() {
  yield takeLeading(CREATE_CIVIL_PROCEEDING, createCivilProceeding);
}
export function* makeRequestAssignedExpert(
  action: IAssignedExpertAction,
): Generator<unknown> {
  const { assignedExpert, successCallback } = action;
  const token = accessTokenStorage.get().token;
  if (!token) return;
  const path = `/corporeal/mission`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...assignedExpert }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
  }
}

export function* makeRequestAssignedExpertSaga() {
  yield takeLeading(REQUEST_ASSIGNED_EXPERT, makeRequestAssignedExpert);
}

export function* validateDisclaimerWarrantyReason(
  action: IWarrantyReasonAction,
): Generator<unknown> {
  const { reason, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/claim`;

  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      id: reason.id,
      claimInfo: { disclaimerWarrantyReasonId: reason.reasonId },
    }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
  }
}

export function* validateDisclaimerWarrantyReasonSaga() {
  yield takeLeading(
    REQUEST_VALIDATE_DISCLAIMER_WARRANTY,
    validateDisclaimerWarrantyReason,
  );
}
export function* validateUpdatedCivilProceeding(
  action: IUpdatedCivilProceedingAction,
): Generator<unknown> {
  const { newCivilProceeding, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/judiciary-process`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...newCivilProceeding }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
    if (get(newCivilProceeding, 'JudiciaryProcessInfo.claimId')) {
      yield put(
        requestGetCivilProceeding(
          get(newCivilProceeding, 'JudiciaryProcessInfo.claimId'),
        ),
      );
      yield put(
        requestClaimRecap(
          get(newCivilProceeding, 'JudiciaryProcessInfo.claimId'),
        ),
      );
    }
  }
}

export function* validateCivilProceedingSaga() {
  yield takeLeading(REQUEST_VALIDATE_CIVIL_PROCEEDING, validateCivilProceeding);
}
export function* validateCivilProceeding(
  action: IUpdatedCivilProceedingAction,
): Generator<unknown> {
  const { newCivilProceeding, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/judiciary-process/validate-judiciary-process`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...newCivilProceeding }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
  }
}

export function* validateUpdatedCivilProceedingSaga() {
  yield takeLeading(REQUEST_UPDATE_CIVIL, validateUpdatedCivilProceeding);
}

export function* requestAddVictims(
  action: IAddVictimsAction,
): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/victim/add-victims`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
    if (payload.provisionalClaimId) {
      yield put(
        requestGetProvisionalClaimDetails(payload.provisionalClaimId, false),
      );
    } else {
      yield put(requestClaimRecap(payload.claimId));
    }
  }
}

export function* requestAddVictimsSaga() {
  yield takeLeading(REQUEST_VALIDATE_ADD_VICTIMS_CARD, requestAddVictims);
}
export function* requestAddVehicles(action: any): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/add-vehicles`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
    yield put(requestClaimRecap(payload.claimId));
  }
}

export function* requestAddVehiclesSaga() {
  yield takeLeading(REQUEST_CREATE_VEHICLES, requestAddVehicles);
}

export function* makeDecisionMissionExpertise(action: any): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = !isEmpty(get(payload, 'sagisEvaluations', {}))
    ? '/corporeal/validate-transaction-export-report'
    : payload.isVehicle
    ? `/corporeal/mission-expertise-vehicle/make-decision`
    : `/corporeal/mission-expertise-victim/make-decision`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallback();
    yield put(
      setDecisionsJudgementIds({
        missionExpertiseId: get(payload, 'id', null),
      }),
    );
    if (!isNil(get(payload, 'transactionId', null))) {
      yield put(
        requestGetMissionVictimExpertise({
          transactionId: get(payload, 'transactionId', null),
        }),
      );
      yield put(
        requestGetTransaction({
          claimId: get(payload, 'claimId', null),
        }),
      );
      yield put(
        requestGetFeeNotesTransaction({
          transactionId: get(payload, 'transactionId', null),
        }),
      );
    } else {
      yield put(
        requestGetExpertiseVictim({
          missionId: null,
          claimId: payload.claimId,
          missionVictimId: null,
          isIntervenant: false,
        }),
      );
      featureService.hasFeature(FEATURES.EVOLUTION_P3)
        ? yield put(
            requestFeeNotesByClaimNumb(get(payload, 'claimNumber'), [], true),
          )
        : yield put(requestFeeNotesByClaimNumb(get(payload, 'claimNumber')));
    }
  }
}

export function* requestMakeDecisionMissionExpertiseSaga() {
  yield takeLeading(
    REQUEST_MAKE_DECISION_MISSION_EXPERTISE,
    makeDecisionMissionExpertise,
  );
}
export function* makeDecisionMissionNoticeDeficiency(
  action: any,
): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/mission-postpone/make-decision`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
    yield put(
      setDecisionsJudgementIds({
        missionPostPoneId: get(payload, 'id', null),
      }),
    );
    featureService.hasFeature(FEATURES.EVOLUTION_P3)
      ? yield put(
          requestFeeNotesByClaimNumb(get(payload, 'claimNumber'), [], true),
        )
      : yield put(requestFeeNotesByClaimNumb(get(payload, 'claimNumber')));
    if (payload.type === MISSION_POSTPONE_TYPE.NOTICE_DEFICIENCY) {
      yield put(
        requestGetMissionPostPone({
          claimId: payload.claimId,
          missionId: null,
          type: MISSION_POSTPONE_TYPE.NOTICE_DEFICIENCY,
          isIntervenant: false,
        }),
      );
    } else {
      yield put(
        requestGetMissionPostPoneExpertise({
          claimId: payload.claimId,
          missionId: null,
          type: MISSION_POSTPONE_TYPE.POSTPONEMENTS_EXPERTISE,
          isIntervenant: false,
        }),
      );
    }
  }
}
export function* requestMakeDecisionMissionNoticeDeficiencySaga() {
  yield takeLeading(
    REQUEST_MAKE_DECISION_MISSION_NOTICE_DEFICIENCY,
    makeDecisionMissionNoticeDeficiency,
  );
}

export function* requestCorporealExperts(action: any) {
  const { payload } = action;
  const token = accessTokenStorage.get().token;
  const options = {
    method: 'GET',
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
  const path = `/corporeal/expert-members?expertiseType=${payload}`;
  yield callApi(path, {}, options, [], requestSetExpertUsers);
}

export function* requestCorporealExpertsSaga() {
  yield takeLeading(REQUEST_GET_EXPERTS_USERS, requestCorporealExperts);
}

export function* makeRequestAddAppreciation(action: any): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = payload.isVehicle
    ? `/corporeal/mission-expertise-vehicle/add-appreciation`
    : `/corporeal/mission-expertise-victim/add-appreciation`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
    if (!isNil(get(payload, 'transactionId', null))) {
      yield put(
        requestGetMissionVictimExpertise({
          transactionId: get(payload, 'transactionId', null),
        }),
      );
      yield put(
        requestGetTransaction({
          claimId: get(payload, 'claimId', null),
        }),
      );
      yield put(
        requestGetFeeNotesTransaction({
          transactionId: get(payload, 'transactionId', null),
        }),
      );
    } else {
      yield put(
        requestGetExpertiseVictim({
          missionId: null,
          claimId: payload.claimId,
          missionVictimId: null,
          isIntervenant: false,
        }),
      );
    }
  }
}
export function* requestAddAppreciationSaga() {
  yield takeLeading(REQUEST_ADD_APPRECIATION, makeRequestAddAppreciation);
}
export function* makeUpdateCivilProceeding(action: any): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = payload.isLawyer
    ? yield select(makeSelectKeycloakToken())
    : accessTokenStorage.get().token;
  const path = `/corporeal/judiciary-process/change-judiciary-process-info`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
    if (get(payload, 'JudiciaryProcessInfo.claimId')) {
      yield put(
        requestGetCivilProceeding(get(payload, 'JudiciaryProcessInfo.claimId')),
      );
      yield put(
        requestClaimRecap(get(payload, 'JudiciaryProcessInfo.claimId')),
      );
    }
  }
}
export function* requestUpdateCivilProceedingSaga() {
  yield takeLeading(REQUEST_UPDATE_CIVIL_PROCEEDING, makeUpdateCivilProceeding);
}
export function* requestSetSuspiciousClaim(action: {
  payload: any;
  successCallback: Function;
  type: string;
}): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/claim`;

  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      ...payload,
    }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield successCallback();
    yield put(requestClaimRecap(payload.id));
  }
}

export function* requestSetSuspiciousClaimSaga() {
  yield takeLeading(REQUEST_SET_IS_SUSPICIOS_CLAIM, requestSetSuspiciousClaim);
}

export function* requestLockClaim(action: {
  payload: any;
  type: string;
}): Generator<unknown> {
  const { payload } = action;
  const token = accessTokenStorage.get().token;
  const path = `/sagis/claim/lock`;
  if (isNil(get(payload, 'claimNumber'))) return null;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      ...payload,
    }),
  };

  yield callApi(path, {}, options);
}

export function* requestLockClaimSaga() {
  yield takeLeading(REQUEST_LOCK_CLAIM, requestLockClaim);
}
export function* requestUnLockClaim(action: {
  payload: any;
  type: string;
  successCallBack?: Function;
}): Generator<unknown> {
  const { successCallBack } = action;
  const token = accessTokenStorage.get().token;
  const path = `/sagis/claim/unlock`;
  let claimNumber = get(action.payload, 'claimNumber', null);
  if (isNil(claimNumber)) {
    claimNumber = yield select(makeSelectLockedClaim());
  }
  if (isNil(claimNumber)) return null;

  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      claimNumber: claimNumber,
    }),
  };

  const response = yield callApi(path, {}, options);
  if (!response && successCallBack) {
    yield successCallBack();
  }
}

export function* requestUnLockClaimSaga() {
  yield takeLeading(REQUEST_UNLOCK_CLAIM, requestUnLockClaim);
}
export function* requestMakeDecisionDocumentImaging(action: {
  payload: any;
  successCallBack: Function;
  type: string;
}): Generator<unknown> {
  const { payload, successCallBack } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/document-imaging`;

  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      ...payload,
    }),
  };

  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
    yield put(
      requestGetPendingTasksClaim({
        claimNumber: payload.claimNumbers,
      }),
    );
    yield put(setNotification(null));
  }
}
export function* requestMakeDecisionDocumentImagingSaga() {
  yield takeLeading(
    MAKE_DECISION_DOCUMENT_IMAGING,
    requestMakeDecisionDocumentImaging,
  );
}
export function* requestCheckCivilPartyJudiciaryProcess(action: any) {
  const { payload } = action;
  const token = accessTokenStorage.get().token;
  const options = {
    method: 'GET',
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
  const path = `/corporeal/common/check-civil-party-judiciary-process?claimId=${payload}`;
  yield callApi(path, {}, options, [], setCheckCivilPartyJudiciaryProcess);
}
export function* requestCheckCivilPartyJudiciaryProcessSaga() {
  yield takeLeading(
    REQUEST_CHECK_CIVIL_PARTY_JUDICIARY_PROCESS,
    requestCheckCivilPartyJudiciaryProcess,
  );
}
export function* makeGetClaimHistoryActions(action: any) {
  const { payload } = action;
  const token = accessTokenStorage.get().token;
  const options = {
    method: 'GET',
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
  const path = `/corporeal/user-actions-history/details?claimId=${payload}`;
  yield callApi(
    path,
    {},
    options,
    [],
    setClaimHistoryActions,
    undefined,
    false,
    LOADERS.TRACKING_USER,
  );
}
export function* requestGetClaimHistoryActionsSaga() {
  yield takeLeading(
    REQUEST_GET_CLAIM_HISTORY_ACTIONS,
    makeGetClaimHistoryActions,
  );
}
export function* makeGetClaimHistorySagis(action: any) {
  const { payload } = action;
  const token = accessTokenStorage.get().token;
  if (!payload) return null;
  const options = {
    method: 'GET',
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
  const path = `/sagis/history-messages/${payload}`;
  yield callApi(
    path,
    {},
    options,
    [],
    setClaimHistorySagis,
    undefined,
    false,
    LOADERS.TRACKING_USER,
  );
}
export function* requestGetClaimHistorySagisSaga() {
  yield takeLeading(REQUEST_GET_CLAIM_HISTORY_SAGIS, makeGetClaimHistorySagis);
}
export function* requestSetStatusClaimSagis(action: {
  payload: any;
  type: string;
  successCallBack: Function;
}): Generator<unknown> {
  const { payload, successCallBack } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/change-status`;
  if (isNil(token)) return null;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
    yield put(requestSagisClaimInfo(get(payload, 'claimNumber'), () => {}));
    yield put(requestGetClaimHistorySagis(get(payload, 'claimNumber')));
  }
}
export function* requestSetStatusClaimSagisSaga() {
  yield takeLeading(REQUEST_SET_STATUS_CLAIM_SAGIS, requestSetStatusClaimSagis);
}

export function* requestUpdatePriorityClaimProvision(action: {
  payload: any;
  type: string;
}): Generator<unknown> {
  const { payload } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/claim`;
  if (isNil(token)) return null;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield put(requestClaimRecap(payload.id));
  }
}
export function* requestUpdatePriorityClaimProvisionSaga() {
  yield takeLeading(
    REQUEST_UPDATE_PRIORITY_CLAIM_PROVISION,
    requestUpdatePriorityClaimProvision,
  );
}

export function* createStakeHolder(
  action: ICreateStakeHolder,
): Generator<unknown> {
  const { payload, successCallBack } = action;
  const token = accessTokenStorage.get().token;
  if (!token) return;
  const path = `/corporeal/assignment/add-stake-holder`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield put(
      requestSagisClaimInfo(get(payload, 'claimNumber'), successCallBack),
    );
    yield put(requestGetClaimHistorySagis(get(payload, 'claimNumber')));
  }
}
export function* createStakeHolderSaga() {
  yield takeLeading(REQUEST_ADD_STAKE_HOLDER, createStakeHolder);
}
export function* requestCreateInstruction(action: {
  payload: any;
  type: string;
  successCallBack: Function;
}): Generator<unknown> {
  const { payload, successCallBack } = action;
  const token = payload.isLawyer
    ? yield select(makeSelectKeycloakToken())
    : accessTokenStorage.get().token;
  const path = `/corporeal/instruction`;
  if (isNil(token)) return null;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
  }
}

export function* requestCreateInstructionSaga() {
  yield takeLeading(REQUEST_CREATE_INSTRUCTIONS, requestCreateInstruction);
}

export function* requestGetInstructions(action: any): Generator<unknown> {
  const {
    payload: { judiciaryProcessId, isIntervenant = false },
  } = action;

  const token = accessTokenStorage.get().token
    ? accessTokenStorage.get().token
    : yield select(makeSelectKeycloakToken());
  const options = {
    method: 'GET',
    headers: {
      authorization: `Bearer ${token}`,
    },
  };
  const path = accessTokenStorage.get().token
    ? `/corporeal/instruction?judiciaryProcessId=${judiciaryProcessId}`
    : `/corporeal/instruction?judiciaryProcessId=${judiciaryProcessId}&isIntervenant=${isIntervenant}`;
  yield callApi(path, {}, options, [], setInstructions);
}
export function* requestGetInstructionsSaga() {
  yield takeLeading(REQUEST_GET_INSTRUCTIONS, requestGetInstructions);
}
export function* requestUpdateInstructionSaga() {
  yield takeLeading(REQUEST_UPDATE_INSTRUCTIONS, requestUpdateInstruction);
}
export function* requestUpdateInstruction(action: {
  payload: any;
  type: string;
  successCallBack: Function;
}): Generator<unknown> {
  const { payload, successCallBack } = action;
  const token = accessTokenStorage.get().token
    ? accessTokenStorage.get().token
    : yield select(makeSelectKeycloakToken());
  const path = `/corporeal/instruction`;
  if (isNil(token)) return null;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
  }
}
export function* requestCreateIncomeCertificate(action: {
  payload: any;
  type: string;
  successCallBack: Function;
}): Generator<unknown> {
  const { payload, successCallBack } = action;
  const token = accessTokenStorage.get().token
    ? accessTokenStorage.get().token
    : yield select(makeSelectKeycloakToken());

  const path = `/corporeal/victim-income-certificate`;
  if (isNil(token)) return null;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };
  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
    yield put(requestClaimRecap(get(payload, 'claimId')));
    yield put(requestGetCivilProceeding(get(payload, 'claimId')));
  }
}
export function* requestCreateIncomeCertificateSaga() {
  yield takeLeading(
    REQUEST_CREATE_INCOME_CERTIFICATE,
    requestCreateIncomeCertificate,
  );
}
export function* requestUpdateIncomeCertificate(action: {
  payload: any;
  type: string;
  successCallBack: Function;
}): Generator<unknown> {
  const { payload, successCallBack } = action;
  const token = accessTokenStorage.get().token
    ? accessTokenStorage.get().token
    : yield select(makeSelectKeycloakToken());

  const path = `/corporeal/victim-income-certificate`;
  if (isNil(token)) return null;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };
  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
    yield put(requestClaimRecap(get(payload, 'claimId')));
    yield put(requestGetCivilProceeding(get(payload, 'claimId')));
  }
}

export function* requestUpdateIncomeCertificateSaga() {
  yield takeLeading(
    REQUEST_UPDATE_INCOME_CERTIFICATE,
    requestUpdateIncomeCertificate,
  );
}
export function* requestMakeDecisionIncomeCertificate(action: {
  payload: any;
  type: string;
  successCallBack: Function;
}): Generator<unknown> {
  const { payload, successCallBack } = action;
  const token = accessTokenStorage.get().token;

  const path = `/corporeal/victim-income-certificate/make-decision`;
  if (isNil(token)) return null;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };
  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
    yield put(requestClaimRecap(get(payload, 'claimId')));
  }
}
export function* requestMakeDecisionIncomeCertificateSaga() {
  yield takeLeading(
    REQUEST_MAKE_DECISION_INCOME_CERTIFICATE,
    requestMakeDecisionIncomeCertificate,
  );
}

export function* requestMakeDecisionSupportDocument(action: {
  payload: any;
  type: string;
  successCallBack: Function;
}): Generator<unknown> {
  const { payload, successCallBack } = action;
  const token = accessTokenStorage.get().token;

  const path = `/corporeal/support-document/make-decision`;
  if (isNil(token)) return null;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };
  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
    if (!isNil(get(payload, 'judgementAddId'))) {
      yield put(
        requestGetJudgementAdd(
          get(payload, 'claimId'),
          get(payload, 'procedureType'),
          get(payload, 'judiciaryProcessId'),
        ),
      );
    } else if (!isNil(get(payload, 'judgementOnMeritsId'))) {
      yield put(
        requestGetJudgementOnMerits(
          get(payload, 'claimId'),
          get(payload, 'procedureType'),
          get(payload, 'judiciaryProcessId'),
        ),
      );
    } else if (!isNil(get(payload, 'expertReportId'))) {
      yield put(
        requestGetExpertiseRaport(
          get(payload, 'claimId'),
          get(payload, 'procedureType'),
          get(payload, 'judiciaryProcessId'),
        ),
      );
    }
  }
}
export function* requestMakeDecisionSupportDocumentSaga() {
  yield takeLeading(
    REQUEST_MAKE_DECISION_SUPPORT_DOCUMENT,
    requestMakeDecisionSupportDocument,
  );
}

export function* makeRequestGetPendingTasksClaim(action: any) {
  const { payload } = action;
  const token = accessTokenStorage.get().token;
  if (!payload) return null;
  const options = {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      claimNumber: payload.claimNumber,
      isImagingDocuments: true,
    }),
  };
  const path = `/corporeal/notification-manager/search-pending-treatement-claims`;
  yield callApi(path, {}, options, [], setPendingTasksClaim);
}

export function* requestGetPendingTasksClaimSaga() {
  yield takeLeading(
    REQUEST_GET_PENDING_TASKS_CLAIM,
    makeRequestGetPendingTasksClaim,
  );
}
export function* requestGetClaimCivilParty(action: any): Generator<unknown> {
  const { payload } = action;
  const token = get(accessTokenStorage.get(), 'token')
    ? get(accessTokenStorage.get(), 'token')
    : yield select(makeSelectKeycloakToken());
  const options = {
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      authorization: `Bearer ${token}`,
    },
  };
  const path = constructUrl(
    `/corporeal/judgement/get-civil-documents/${payload.claimId}`,
  );
  yield callApi(path, {}, options, [], setClaimCivilParty);
}
export function* requestGetClaimCivilPartySaga() {
  yield takeLeading(REQUEST_GET_CLAIM_CIVIL_PARTY, requestGetClaimCivilParty);
}
export function* requestArchiveJudgement(action: {
  payload: any;
  type: string;
  successCallBack: Function;
}): Generator<unknown> {
  const { payload, successCallBack } = action;
  const token = accessTokenStorage.get().token;

  const path = `/corporeal/judgement/hide`;
  if (isNil(token)) return null;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };
  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
    yield put(
      requestGetJudgementOnMerits(
        get(payload, 'claimId'),
        get(payload, 'procedureType'),
        get(payload, 'judiciaryProcessId'),
      ),
    );
    yield put(
      get(payload, 'procedureType') === PROCEDURE_TYPES.APPEAL
        ? requestGetAppealOnMeritsMultiple(
            get(payload, 'claimId'),
            get(payload, 'procedureType'),
            get(payload, 'judiciaryProcessId'),
          )
        : requestGetJudgementOnMeritsMultiple(
            get(payload, 'claimId'),
            get(payload, 'procedureType'),
            get(payload, 'judiciaryProcessId'),
          ),
    );
  }
}

export function* requestArchiveJudgementSaga() {
  yield takeLeading(REQUEST_ARCHIVE_JUDGEMENT, requestArchiveJudgement);
}

export function* requestUploadDocumentManager(action: {
  payload: any;
  type: string;
  successCallBack: Function;
}): Generator<unknown> {
  const { payload, successCallBack } = action;
  const token = accessTokenStorage.get().token;

  const path = `/sagis/documentum/v2/upload-documents`;
  if (isNil(token)) return null;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };
  const errorResponse = yield callApi(path, {}, options);
  if (!errorResponse) {
    yield successCallBack();
    yield put(
      requestSearchClaims({
        claimNumber: get(payload, 'claimExtCode'),
        withDocuments: 'Y',
      }),
    );
  }
}

export function* requestUploadDocumentManagerSaga() {
  yield takeLeading(
    REQUEST_UPLOAD_DOCUMENT_MANAGER,
    requestUploadDocumentManager,
  );
}
export function* requestGetDecisionFlowVictims(action: {
  claimId: number;
  type: string;
}): Generator<unknown> {
  const { claimId } = action;
  const token = accessTokenStorage.get().token;

  const path = `/corporeal/common/victims/${claimId}`;
  if (isNil(token)) return null;
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };
  yield callApi(path, {}, options, [], setDecisionFlowVictims);
}
export function* requestGetDecisionFlowVictimsSaga() {
  yield takeLeading(
    REQUEST_GET_DECISION_FLOW_VICTIMS,
    requestGetDecisionFlowVictims,
  );
}
export default [
  makeJudgementAddDecisionSaga,
  validateExpertReportSaga,
  validateJudgementOnMeritsSaga,
  validateJudgementAppealSaga,
  validateDisclaimerWarrantyReasonSaga,
  createCivilProceedingSaga,
  makeRequestAssignedExpertSaga,
  validateUpdatedCivilProceedingSaga,
  validateCivilProceedingSaga,
  makeJudgementAddDocumentDecisionSaga,
  requestAddVictimsSaga,
  requestAddVehiclesSaga,
  requestMakeDecisionMissionExpertiseSaga,
  requestMakeDecisionMissionNoticeDeficiencySaga,
  requestCorporealExpertsSaga,
  requestAddAppreciationSaga,
  requestUpdateCivilProceedingSaga,
  requestSetSuspiciousClaimSaga,
  requestCreateJudgementAddSaga,
  requestLockClaimSaga,
  requestUnLockClaimSaga,
  requestMakeDecisionDocumentImagingSaga,
  requestCheckCivilPartyJudiciaryProcessSaga,
  requestGetClaimHistoryActionsSaga,
  requestGetClaimHistorySagisSaga,
  requestSetStatusClaimSagisSaga,
  createStakeHolderSaga,
  requestUpdatePriorityClaimProvisionSaga,
  requestGetInstructionsSaga,
  requestCreateInstructionSaga,
  requestUpdateInstructionSaga,
  requestCreateIncomeCertificateSaga,
  requestUpdateIncomeCertificateSaga,
  requestMakeDecisionIncomeCertificateSaga,
  requestMakeDecisionSupportDocumentSaga,
  requestGetPendingTasksClaimSaga,
  requestGetClaimCivilPartySaga,
  requestArchiveJudgementSaga,
  requestUploadDocumentManagerSaga,
  requestGetDecisionFlowVictimsSaga,
];
